import(/* webpackMode: "eager", webpackExports: ["FilterMenu"] */ "/vercel/path0/src/app/spots/components/FilterMenu.tsx");
